import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'

import { Path, ExternalPath } from "../../constants/path";
import { settings } from "../../assets/settings";
import { Link, Button } from "../util/Clickable";
import SearchHeaderForm from "../forms/SearchHeaderForm";

import logo_w from "../../assets/images/logo_light.png";

declare var UIkit;

class Header extends Component {

  state = {
    query: null,
    showModal:false
  }

  searchToggle = null;

  componentWillMount = () => {
    this.setState({
      query: null
    }, () => {
      this.locationToQuery(this.props.location);
    });
  }

  componentWillReceiveProps = (nextProps) => {
    
    if( this.props.location.pathname != nextProps.location.pathname || this.props.location.search != nextProps.location.search ){
      this.locationToQuery(nextProps.location);
    }
  }

  locationToQuery = (location) => {
    const query = qs.parse(location.search.replace("?", ""));
    this.setState({
      query: Object.assign({}, settings.search_default(), query)
    })
  }

  closeSidebar = () => {
    if( this.sidebar ){
      UIkit.offcanvas(this.sidebar).hide();  
    }
  }

  onToggleSearch = () => {
    this.setState({
      showModal: !this.state.showModal
    })
  }

  onSearch = (values) => {
    this.onToggleSearch();
    const param = qs.stringify(values);
    this.props.history.push( this.props.location.pathname + "?" + param );
  }

  render = () => {
    return (
      <div>
        <div className="uk-background-muted">
          <div className="uk-container uk-container-small">
            <p className="uk-margin-remove">
              <small>{settings.lead}</small>
            </p>
          </div>
        </div>
        <div {...{'uk-sticky': 'sel-target: > div; cls-active: uk-navbar-sticky; show-on-up: true;'}}>
          <div className="uk-box-shadow-small uk-navbar-base">
            <header className="uk-container uk-container-small">
              <nav className="uk-navbar-container uk-navbar-transparent" data-uk-navbar>
                <div className="uk-navbar-left">
                    <img className="uk-height-logo" src={logo_w} alt={settings.title} />
                </div>
                <div className="uk-navbar-right uk-visible@s">
                  <ul className="uk-navbar-nav">
                    <li>
                      <Link to={Path.facilities.url+this.props.location.search}>
                        <span className="uk-margin-small-right" data-uk-icon="icon:search;"></span>
                        リストで表示
                      </Link>
                    </li>
                    <li>
                      <Link to={Path.map.url+this.props.location.search}>
                        <span className="uk-margin-small-right" data-uk-icon="icon:location;"></span>
                        地図で表示
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="uk-navbar-right uk-hidden@s">
                  <ul className="uk-navbar-nav">
                    <li>
                      <Link className="uk-navbar-toggle" onClick={this.onToggleSearch}>
                        <span data-uk-icon="icon:search;"></span> 
                      </Link>
                    </li>
                    <li>
                      <Link className="uk-navbar-toggle uk-padding-remove" {...{'uk-toggle': 'target: #side-menu;'}}>
                        <span {...{'uk-navbar-toggle-icon': ''}}></span> 
                      </Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </header>
          </div>
        </div>
        <div id="side-menu" data-uk-offcanvas="flip: true; overlay: true" ref={ sidebar => this.sidebar = sidebar }>
          <div className="uk-offcanvas-bar">
            <button className="uk-offcanvas-close" type="button" data-uk-close></button>
            <h3>
              MENU
            </h3>
            <div className="uk-margin">
              <Link to={Path.root.url} className="uk-button uk-button-text" onClick={this.closeSidebar}>
                トップページ
              </Link>
            </div>
            <div className="uk-margin">
              <Link to={Path.facilities.url+this.props.location.search} className="uk-button uk-button-text" onClick={this.closeSidebar}>
                <span className="uk-margin-small-right" data-uk-icon="icon:search;"></span>
                キーワード・条件で検索
              </Link>
            </div>
            <div className="uk-margin">
              <Link to={Path.map.url+this.props.location.search} className="uk-button uk-button-text" onClick={this.closeSidebar}>
                <span className="uk-margin-small-right" data-uk-icon="icon:location;"></span>
                地図で検索
              </Link>
            </div>
            <hr/>
            <div className="uk-margin uk-text-center">
              <img className="uk-width-1-1" src={logo_w} alt={settings.title} />
            </div>
          </div>
        </div>
        {
          this.state.showModal && (
            <div ref={modal => this.modal = modal} id="mobile-search" className="uk-background-primary uk-position-fixed uk-position-cover uk-position-z-index-1000 uk-overflow-auto">
              <div className="uk-padding-small uk-margin-large-top">
                <div className="uk-background-muted uk-padding-small">
                  {
                    this.state.query && (
                      <SearchHeaderForm onSubmit={ this.onSearch } initialValues={this.state.query} />
                    )
                  }
                </div>
              </div>
              <div className="uk-position-small uk-position-top-right uk-light">
                <Link onClick={this.onToggleSearch}>
                  <span data-uk-icon="icon:close;"></span> 
                </Link>
              </div>
            </div>            
          )
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    constant: state.constant
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
